import { CalculatorId } from '../../../lib/calculators/calculator-config';
import type { CalculatorDescription } from '../../../lib/calculators/calculator-description';

export const fiveNumberSummaryDescription: CalculatorDescription = {
  id: CalculatorId.FIVE_NUMBER_SUMMARY,
  title: 'Five Number Summary Calculator',
  metaTitle: 'Online Five Number Summary Calculator - Statistical Analysis Tool',
  description: 'Calculate the five number summary (minimum, Q1, median, Q3, maximum) of your dataset. Perfect for understanding data distribution and identifying key statistical points.',
  metaDescription: 'Calculate five number summary online. Find minimum, quartiles, median, and maximum with our free calculator. Perfect for statistical analysis and data exploration.',
  howTo: {
    title: 'How to Calculate Five Number Summary',
    steps: [
      'Enter your dataset or select a data column',
      'View the calculated minimum, Q1, median, Q3, and maximum',
      'Analyze the distribution visualization',
      'Interpret the results to understand your data spread'
    ],
    graphic: {
      description: 'A shadcn data table for input with calculated statistics and distribution visualization'
    }
  },
  examples: [
    {
      title: 'Student Test Scores',
      description: 'Analysis of test scores in a class',
      dataDescription: 'Test scores ranging from 0 to 100',
      insights: [
        'Shows overall score distribution',
        'Identifies median performance',
        'Reveals score spread through quartiles',
        'Highlights extreme values'
      ]
    },
    {
      title: 'Monthly Sales Data',
      description: 'Analysis of monthly sales figures',
      dataDescription: 'Sales amounts over multiple months',
      insights: [
        'Shows typical sales range',
        'Identifies median monthly sales',
        'Reveals sales variability',
        'Highlights exceptional months'
      ]
    }
  ],
  relatedCalculators: [
    CalculatorId.BoxPlot,
    CalculatorId.STANDARD_DEVIATION,
    CalculatorId.MEAN,
    CalculatorId.VARIANCE
  ]
}; 